import React, { createRef, useEffect, useState } from 'react';
import i18n from "i18next";
import {connect} from 'react-redux';

import ListActionButtons from './list-action-buttons';
import { setShowPreview } from '../../actions/application';
import HideIcon from '../../assets/icons/hide.svg?react';
import ShowIcon from '../../assets/icons/show.svg?react';
import SyncButton from './sync-button';
import MessagesFilter from './messages-filter';
import './list-toolbar.scss';

const Toolbar = ({
  selectedMessages,
  onDeleteClick,
  selectedMessagesAllUnread,
  onMarkReadClick,
  onMarkUnreadClick,
  onRefreshClick,
  updatedShowPreview,
  showPreview
}) => {
  const [displayExpandedToolbar, setDisplayExpandedToolbar] = useState(true);
  const MIN_TOOLBAR_WIDTH_PX = 1200;
  const toolbarRef = createRef();

  useEffect(() => {
    const toolbarElement = toolbarRef.current;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.contentRect.width < MIN_TOOLBAR_WIDTH_PX) {
          setDisplayExpandedToolbar(false);
        } else {
          setDisplayExpandedToolbar(true);
        }
      }
    });

    if (toolbarElement) {
      resizeObserver.observe(toolbarElement);
    }

    return () => {
      if (toolbarElement) {
        resizeObserver.unobserve(toolbarElement);
      }
    };
  }, []);

  return (<div className={'msg-toolbar'} ref={toolbarRef}>
    <div className="pl-2 py-2 pr-4 d-flex align-items-center bd-highlight">
      <div className="d-flex align-content-center align-items-center ">
        <div className="px-1 bd-highlight">
          <ListActionButtons
            selectedMessages={selectedMessages}
            selectedMessagesCounter={selectedMessages.length}
            selectedMessagesAllUnread={selectedMessagesAllUnread}
            markAsRead={onMarkReadClick}
            markAsUnread={onMarkUnreadClick}
            onDeleteClick={onDeleteClick}
            hideText={!displayExpandedToolbar}
          />
        </div>
      </div>

      <div className={'right-buttons'}>
        <SyncButton onSyncClick={onRefreshClick} />
        <MessagesFilter/>
        <div className="toolbar-divider"/>
        <div
          className={`
            d-flex
            align-items-center
            toolbar-preview-container
            ${!showPreview ? 'w-preview' : 'w-hide-preview'}`
          }
          onClick={() => {
            updatedShowPreview(!showPreview);
          }}
        >
          {!showPreview ? <ShowIcon /> : <HideIcon />}
          <span
            className="ml-2 text-color-blue-lefebvre inter-semibold-14">
            {!showPreview ? i18n.t('topBar.preview') : i18n.t('topBar.hide_preview')}
          </span>
        </div>
      </div>
    </div>
  </div>);
};

const mapStateToProps = state => ({
  showPreview: state.application.showPreview
});

const mapDispatchToProps = dispatch => ({
  updatedShowPreview: showPreview => dispatch(setShowPreview(showPreview))
});

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
